import React from 'react'
import { Row, Col, Form } from 'react-bootstrap'
import { CardChecklist } from 'react-bootstrap-icons'
import useViewport from '../../../hooks/use-viewport'
import Toggle from 'react-toggle'

const PrivateToggle = ({
    value,
    onChange = () => {}
}) => {
    const { breakpoint, breakpoints } = useViewport()
    return (
        <Form.Group as={Row}>
            <Form.Label column sm={12} md={1} lg={2} xl={3}>
                <CardChecklist size={30} /> {breakpoint >= breakpoints.XL || breakpoint <= breakpoints.SM ? 'Private List Visiblity' : ''}
            </Form.Label>
            <Col sm={12} md={11} lg={10} xl={3} style={{ display: 'flex', justifyContent: 'row', alignContent: 'center', alignItems: 'center'}}>
                <Toggle
                    checked={Boolean(value)}
                    onChange={e => onChange(e.target.checked)}
                    icons={false}
                />
            </Col>
        </Form.Group>
    )
}

export default PrivateToggle
